import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader.component';


@NgModule({
    declarations: [LoaderComponent],
    imports: [],
    exports: [LoaderComponent]
})
export class LoaderModule {}
